import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";
import { formatErr } from "../lib/api";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => { e.preventDefault(); setLoading(true);
    try { await register(form); toast.success("Account created"); nav("/"); }
    catch (e) { toast.error(formatErr(e)); } finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen bg-white grid md:grid-cols-2">
      <div className="hidden md:block relative"><img src="https://images.pexels.com/photos/22032441/pexels-photo-22032441.jpeg?w=1200" alt="" className="w-full h-full object-cover"/></div>
      <div className="flex items-center justify-center p-10 md:p-20">
        <div className="w-full max-w-sm">
          <Link to="/" className="overline mb-8 block">← Back to Luxe Watches</Link>
          <h1 className="font-display text-4xl text-dark mb-3">Create account</h1>
          <p className="text-sm text-gray-500 mb-10">Join our private clientele.</p>
          <form onSubmit={submit} className="space-y-6">
            <input data-testid="reg-name" required placeholder="Full Name" className="input-luxe" value={form.name} onChange={(e)=>setForm({...form, name:e.target.value})}/>
            <input data-testid="reg-email" type="email" required placeholder="Email" className="input-luxe" value={form.email} onChange={(e)=>setForm({...form, email:e.target.value})}/>
            <input data-testid="reg-phone" placeholder="Phone (optional)" className="input-luxe" value={form.phone} onChange={(e)=>setForm({...form, phone:e.target.value})}/>
            <input data-testid="reg-password" type="password" required placeholder="Password" className="input-luxe" value={form.password} onChange={(e)=>setForm({...form, password:e.target.value})}/>
            <button data-testid="reg-submit" disabled={loading} className="btn-primary w-full justify-center">{loading? "Creating…" : "Create account"}</button>
          </form>
          <p className="text-sm text-gray-500 mt-8">Already have an account? <Link to="/login" className="text-copper hover:text-[#A0834F]">Sign in</Link></p>
        </div>
      </div>
    </div>
  );
}
